import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { CodeSvg } from './Code';

export const CodeIcon = createIcon('code', CodeSvg);
/**
 * @deprecated используйте CodeIcon
 */
export const withCodeIcon = withIcon('code', CodeSvg);
